<template>
  <section class="bg-static-info-mid relative py-28">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <h1 class="heading-1">
        {{ i18n(translations.title) }}
      </h1>

      <RevInputAutocomplete
        v-if="displayArticlesSearch"
        id="help-center-search"
        v-model="search"
        class="mt-12"
        :clearButtonAriaLabel="i18n(translations.clearButtonAriaLabel)"
        :has-cleaning-icon="false"
        :icon="IconSearch"
        :label="i18n(translations.searchLabel)"
        :options
        type="text"
        @select-item="(s) => handleSelectedItem(s as { url?: string })"
      />
    </div>
    <div
      class="relative mx-auto max-w-full px-24 py-28 md:max-w-[1184px] md:px-32"
    >
      <ErrorContainer
        v-if="categoriesError"
        data-qa="help-home-faq-categories-error"
        @retry="refreshCategories"
      />
      <FAQCategories v-else-if="categories?.length" :categories />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { watch } from 'vue'

import { useCareLogger } from '@backmarket/nuxt-layer-care-platform/useCareLogger'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputAutocomplete } from '@ds/components/InputAutocomplete'
import { IconSearch } from '@ds/icons/IconSearch'

import ErrorContainer from '@/scopes/care-commons/components/ErrorContainer/ErrorContainer.vue'

import translations from './FAQSection.translations'
import FAQCategories from './components/FAQCategories/FAQCategories.vue'
import { useFAQArticleSearch } from './useFAQArticleSearch'

const i18n = useI18n()
const $httpFetch = useHttpFetch()
const { logHttpError } = useCareLogger()

const { search, options, handleSelectedItem, displayArticlesSearch } =
  useFAQArticleSearch()

const {
  data: categories,
  error: categoriesError,
  refresh: refreshCategories,
} = useAsyncData(async () => {
  return $httpFetch('/api/care-platform/external/v1/help-center/categories')
})

watch(categoriesError, () => {
  if (!categoriesError.value) return

  logHttpError({
    error: categoriesError.value,
    errorStatusCode: categoriesError.value.status ?? 0,
    errorDetail: { scope: 'help_center' },
    errorTitle: '[HELP CENTER] Error when fetching FAQ categories',
  })
})
</script>
